import { createFileRoute } from '@tanstack/react-router';
import { redirectPostRegistrationToRoot } from './-post-registration-redirect';

export const Route = createFileRoute('/post_registration/$')({
  beforeLoad: redirectPostRegistrationToRoot,
});
